import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../../../_metronic/layout/core'
import TransactionPaymentFormComponent from '../components/transaction-payment-form.component'
import TransactionPaymentListWrapper from '../components/transaction-payments-list.component'
// import TransactionPaymentListWrapper from '../components/transaction-payments-list.component';

const transactionPaymentsBreadcrumbs: Array<PageLink> = [
  {
    title: 'Payment Management',
    path: '/apps/finance/payment-management/payments',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const TransactionPaymentPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='payments'
          element={
            <>
              <PageTitle breadcrumbs={transactionPaymentsBreadcrumbs}>Payment List</PageTitle>
              <TransactionPaymentListWrapper />
            </>
          }
        />
        <Route
          path='payments-form'
          element={
            <>
              <PageTitle breadcrumbs={transactionPaymentsBreadcrumbs}>Payment List</PageTitle>
              <TransactionPaymentFormComponent />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/finance/payment-management/payments' />} />
    </Routes>
  )
}

export default TransactionPaymentPage
